// extracted by mini-css-extract-plugin
export default {"container":"Carousel_container__T85MH","slide":"Carousel_slide__iRw11","button":"Carousel_button__Fl0fN"};